module.exports = __webpack_public_path__ + "static/hover-download-icon@3x-c6fe235440f452cf0e978e3f11f48f22.png";